export default __webpack_public_path__ + "static/media/ic-nl.53d1c86a.svg";